import { resolveLineCompareAxisDimension } from '../../statistics/filters/lib/statisticsTrendDimension';
import { getOrderStatisticsPrimaryPhase } from '../../statistics/charts/pipeline/lib/orderPrimaryPhaseConfig';
import {
	ORDER_PRIMARY_PHASE_LINE_ITEM_DIMENSIONS,
	resolveOrderDimensionKey,
	resolveOrderLineItemDimensionBuckets,
} from '../../statistics/charts/pipeline/lib/orderPrimaryPhaseDimension';
import filterOrdersByCreatedDateRange from './filterOrdersByCreatedDateRange';
import { resolveCompositionChartDimensionBucket } from '../../statistics/charts/composition/lib/compositionChartBuckets';
import { COMPOSITION_CHART_LINE_ITEM_DIMENSIONS } from '../../statistics/charts/composition/lib/compositionChartConfig';
import { resolveProvinceMapNameFromCityCode } from '../../statistics/charts/pipeline/lib/orderPrimaryPhaseGeoBuckets';

/** 行维度（厂家/品牌/品类等）按 orderItems 展开，与出图桶 key 对齐 */
const orderMatchesDimensionKey = (order, dimension, dimensionKey) => {
	if (!dimension || !dimensionKey) return false;
	if (ORDER_PRIMARY_PHASE_LINE_ITEM_DIMENSIONS.has(dimension)) {
		return resolveOrderLineItemDimensionBuckets(order, dimension).some((bucket) => bucket.key === dimensionKey);
	}
	return resolveOrderDimensionKey(order, dimension) === dimensionKey;
};

export const filterHomeDashboardChartDrillOrders = (orders = [], drill = null, context = {}) => {
	const list = Array.isArray(orders) ? orders : [];
	if (!drill) return list;

	const { selectedPhase = null } = context;

	return list.filter((order) => {
		if (drill.kind === 'phase') {
			return Boolean(drill.phase) && getOrderStatisticsPrimaryPhase(order) === drill.phase;
		}

		if (drill.kind === 'overdue') {
			const ids = new Set((drill.orderIds ?? []).map(String).filter(Boolean));
			if (!ids.size) return false;
			return ids.has(String(order?._id ?? '')) || ids.has(String(order?.orderId ?? ''));
		}

		if (selectedPhase && getOrderStatisticsPrimaryPhase(order) !== selectedPhase) {
			return false;
		}

		if (drill.kind === 'dimension') {
			return orderMatchesDimensionKey(order, drill.dimension, drill.dimensionKey);
		}

		if (drill.kind === 'custom') {
			const keys =
				drill.dimensionKey === '__other__'
					? (Array.isArray(drill.otherKeys) ? drill.otherKeys.filter(Boolean) : [])
					: drill.dimensionKey
						? [drill.dimensionKey]
						: [];
			if (!keys.length) return false;
			if (COMPOSITION_CHART_LINE_ITEM_DIMENSIONS.has(drill.dimension)) {
				return keys.some((dimensionKey) => orderMatchesDimensionKey(order, drill.dimension, dimensionKey));
			}
			const { key } = resolveCompositionChartDimensionBucket(order, drill.dimension);
			return keys.includes(key);
		}

		if (drill.kind === 'trend') {
			const dimension = resolveLineCompareAxisDimension(drill.trendAxisMode);
			return orderMatchesDimensionKey(order, dimension, drill.dimensionKey);
		}

		if (drill.kind === 'trendTime') {
			if (!drill.startDate || !drill.endDate) return false;
			return filterOrdersByCreatedDateRange([order], drill.startDate, drill.endDate, drill.dateField).length > 0;
		}

		if (drill.kind === 'geo') {
			const cityCode = String(order?.customerCity ?? order?.customerCityCode ?? order?.customerInfo?.cityCode ?? '').trim();
			let geoMatched = false;
			if (drill.cityCode) {
				geoMatched = cityCode === String(drill.cityCode);
			} else if (drill.provinceName) {
				if (/^\d{6}$/.test(cityCode)) {
					geoMatched = resolveProvinceMapNameFromCityCode(cityCode) === drill.provinceName;
				} else {
					const province = order?.customerProvince ?? order?.customerInfo?.province ?? '';
					geoMatched = province === drill.provinceName;
				}
			}
			if (!geoMatched) return false;
			if (drill.startDate && drill.endDate) {
				return filterOrdersByCreatedDateRange([order], drill.startDate, drill.endDate, drill.dateField).length > 0;
			}
			return true;
		}

		return false;
	});
};

export default filterHomeDashboardChartDrillOrders;
